import React, { useState } from 'react'
import { useMedia } from 'react-use'
import styled from 'styled-components'
import { colors } from '~/design'
import Modal, { ModalStyle } from '~/prix/react/components/modal'
import OriginalLink from '~/prix/react/components/link'
import LeftArrowIcon from '~/meta/angle-left-arrow.svg'
import SearchField from '~/prix/react/components/form/inputs/searchField'
import { searchQueryToRegularExpression } from '~/prix/utils/types/regularExpression'
import { unaccent } from '~/prix/naturalLanguage/unaccent'
import { Level } from './legalEntityGeoprocessingMapLevels.data'
import { ListFooter } from '~/components/list'

export const Link = styled(OriginalLink)`
  text-decoration: none;
  color: #fff;
  padding: 10px 10px 10px 10px;
  transition-duration: 0.5s;
  text-align: center;
  border-radius: 5px;
  background-color: ${colors.sebraeBlue};
  margin-bottom: 10px;
  width: 200px;

  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  span {
    margin-left: 5px;
  }

  &:hover {
    background-color: ${colors.oceanBlue};
  }
`

export const TitleWrapper = styled.div`
  display: inline-flex;
  flex-flow: row nowrap;
  max-width: 100%;
  span {
    font-size: 14px;
    flex: 1;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const SubtitleWrapper = styled.div`
  span {
    font-size: 12px;
  }
`
export const LegalEntityListTitle = styled.span`
  padding: 0.75em 0.75em;
  text-align: center;
  color: #414141;
`

const EntitiesSection = styled.div`
  display: flex;
  margin: 25px 32px;
  padding: 0px 0px;
  flex-direction: column;
  flex-shrink: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
`

const BodyWrapper = styled.div`
  background-color: #fff;
  border-radius: 0 0 12px 12px;
  display: flex;
  flex-direction: column;
`

const CardEntitiesList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const CardEntitiesListTitle = styled.div`
  display: flex;
  border-radius: 12px 12px 0px 0px;
  background: #0f438a;
  padding: 0 25px;
  width: 100%;
  gap: 12px;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  button {
    height: 3rem;
    width: 3rem;
    padding: 8px;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    cursor: pointer;

    border: none;
    border-radius: 100px;
    background: #005eb8;

    svg {
      margin-top: 2px;
      fill: #fff;
    }
  }

  h3 {
    color: #fff;
    font-weight: 400;
    line-height: 23.3px;
    font-size: 2rem;
  }

  div {
    min-width: 3rem;
  }
`

const ListHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 46px;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  flex-shrink: 0;
  background-color: #fff;
`

const ListHeaderColumn = styled.div`
  display: block;
  flex: 1;
  padding-left: 24px;

  color: #8b99a7;
  font-size: 0.89rem;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const ListRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 46px;
  align-items: center;
`

const LegalEntityListButton = styled.button`
  text-align: left;
  border: none;
  background: transparent;
  border-radius: 2px;
  color: rgb(119, 119, 119);
  cursor: pointer;
  border-bottom: 1px solid #e6e6e6;

  &:hover {
    background-color: rgb(245, 245, 245);
    color: rgb(54, 54, 54);
    border-bottom: 1px solid transparent;
  }

  small {
    background-color: ${colors.sebraeBlue};
    color: #fff;
    border-radius: 4px;
    font-weight: bold;
    padding: 0px 3px 1px 2px;
    white-space: nowrap;
  }
`

export const OverlayLoading = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 94, 184, 0.6);
  backdrop-filter: blur(5px);
  z-index: 1;
  align-items: center;
  text-align: center;

  .center {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .message {
      margin-top: 10px;
      color: #fff;
      font-weight: bold;
      text-shadow: 0 5px 5px rgba(0, 0, 0, 0.05);
    }
  }

  .center-error {
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 30px 30px 20px 30px;
    background-color: #fff;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    cursor: default;

    .row {
      display: flex;
      flex-direction: row;
    }

    .column {
      display: flex;
      flex-direction: column;
      margin-right: 5px;
    }

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
    }
  }
`

export const OverlaySearchableMap = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 94, 184, 0.6);
  z-index: 1;
  align-items: center;
  text-align: center;

  span {
    font-size: 16px;
    padding: 20px 40px 20px 40px;
  }

  .center {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fafafa;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    padding: 15px 0px 15px 0px;

    .message {
      margin-top: 10px;
      color: #fff;
      font-weight: bold;
      text-shadow: 0 5px 5px rgba(0, 0, 0, 0.05);
    }
  }

  .center-error {
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 30px 30px 20px 30px;
    background-color: #fff;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    cursor: default;

    .row {
      display: flex;
      flex-direction: row;
    }

    .column {
      display: flex;
      flex-direction: column;
      margin-right: 5px;
    }

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
    }
  }
`

const ListData = styled.div`
  display: block;
  flex: 1;
  overflow: hidden;
  color: #394d60;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.89655rem;
  font-weight: 400;
  padding-left: 23px;
  padding-top: 5px;
`

const HighlightWrapper = styled.div`
  max-width: 75px;
  background-color: ${colors.sebraeBlue};
  color: #fff;
  border-radius: 6px;
  font-weight: bold;
  padding-top: 3px;
  padding-bottom: 3px;
  text-align: center;
`

const writeEntitiesList = (data: any) => {
  const maskCNPJ = (cnpj: string) => {
    const maskedCNPJ = cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    return maskedCNPJ
  }

  const separatedName = data.name.split(' (')
  const name = separatedName[0]
  const cnpj = separatedName[1]?.replace(')', '')

  const maskedCNPJ = cnpj ? maskCNPJ(cnpj) : ''

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', maxWidth: '100%' }}>
      <ListData style={{ maxWidth: '50%' }}>{name}</ListData>
      <ListData style={{ maxWidth: '30%' }}>{maskedCNPJ}</ListData>
      <ListData style={{ maxWidth: '20%' }}>
        {data.highlight ? <HighlightWrapper>Destacado</HighlightWrapper> : null}
      </ListData>
    </div>
  )
}

function LegalEntityModalList({
  isOpen,
  onClose,
  modalStyle,
  onLevelChange,
  selectedLegalEntities,
  setSelectedLegalEntities,
}: {
  isOpen: boolean
  onClose: () => void
  modalStyle?: ModalStyle
  onLevelChange: (level: Level) => void
  selectedLegalEntities: Array<{
    id: string
    name: string
    highlight: boolean | null
  }> | null
  setSelectedLegalEntities: (
    selectedLegalEntities: Array<{
      id: string
      name: string
      highlight: boolean | null
    }> | null,
  ) => void
}) {
  const [currentPage, setCurrentPage] = useState(1)
  const [legalEntityModalSearch, setLegalEntityModalSearch] = useState<string | null>(null)

  const isMobile = useMedia('(max-width: 768px)')

  const listData = selectedLegalEntities?.filter(item =>
    searchQueryToRegularExpression(unaccent(legalEntityModalSearch || '')).test(
      unaccent(item.name),
    ),
  )
  const itemsPerPage = isMobile ? 7 : 8
  const sort = listData?.sort((a, b) => {
    if (a.highlight && !b.highlight) return -1
    if (!a.highlight && b.highlight) return 1
    return 0
  })
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = currentPage * itemsPerPage
  const currentData = sort?.slice(startIndex, endIndex)

  const nextPage = () => {
    setCurrentPage(prevPage => prevPage + 1)
  }

  const prevPage = () => {
    setCurrentPage(prevPage => prevPage - 1)
  }

  const goToPage = (page: number) => {
    setCurrentPage(page)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalStyle={modalStyle ?? 'halfScreen'}
      hideCloseButton={true}
      customStyles={{
        content: {
          maxWidth: '100%',
          background: 'transparent',
        },
      }}
      scrollY={isMobile ? true : false}
    >
      <EntitiesSection>
        <CardEntitiesList>
          <CardEntitiesListTitle>
            <button
              onClick={() => {
                setSelectedLegalEntities(null)
                setLegalEntityModalSearch(null)
              }}
            >
              <LeftArrowIcon fill='#FFF' />
            </button>
            <h3>Lista de empresas</h3>
            <div />
          </CardEntitiesListTitle>
        </CardEntitiesList>
        <BodyWrapper>
          {selectedLegalEntities && selectedLegalEntities.length > 10 && (
            <SearchField
              value={legalEntityModalSearch || ''}
              onChange={setLegalEntityModalSearch}
            />
          )}
          <ListHeaderRow>
            <ListHeaderColumn>Nome da Empresa</ListHeaderColumn>
            <ListHeaderColumn>CNPJ</ListHeaderColumn>
          </ListHeaderRow>
          {currentData && (
            <React.Fragment>
              {currentData.map(currentLegalEntity => (
                <LegalEntityListButton
                  key={currentLegalEntity.id}
                  onClick={event => {
                    event.preventDefault()
                    onLevelChange({
                      geo: 'legalEntity',
                      id: currentLegalEntity.id,
                    })
                  }}
                >
                  <ListRow>{writeEntitiesList(currentLegalEntity)}</ListRow>
                </LegalEntityListButton>
              ))}
              <ListFooter
                currentPage={currentPage}
                totalPages={listData ? Math.ceil(listData.length / itemsPerPage) : 0}
                itemsPerPage={itemsPerPage}
                totalItems={listData ? listData.length : 0}
                onNextPage={nextPage}
                onPrevPage={prevPage}
                onGoToPage={goToPage}
              />
            </React.Fragment>
          )}
        </BodyWrapper>
      </EntitiesSection>
    </Modal>
  )
}

export default LegalEntityModalList
